import { DefaultTheme } from "styled-components";

const CrossMarketTheme: DefaultTheme = {
	colors: {
		primary: "#fcb415",
		primaryHighlight: "#e9aa00",
		primaryDisabled: "#fcb415",
		secondary: "#0d293e",
		secondaryHighlight: "#051828",
		secondaryDisabled: "#0d293e",
		default: "#fff",
		defaultHighlight: "#e6e6e6",
		defaultDisabled: "#adadad",
		defaultBorder: "#ccc",
		background: "#fff",
		textPrimary: "#777",
		textSecondary: "#b3b3b3",
		error: "#d9534f"
	},
	margins: {
		top: "20px",
		bottom: "20px"
	}
};

export default CrossMarketTheme;